import gql from 'graphql-tag';

export const GetLaunchDarklyFlag = gql`
  query LaunchDarklyFlag(
    $customerId: String!
    $country: String!
    $flagName: String!
    $customContext: JSON!
  ) {
    LaunchDarklyFlag(
      customerId: $customerId
      country: $country
      flagName: $flagName
      customContext: $customContext
    ) {
      response
    }
  }
`;
